import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

@Injectable({
    providedIn: 'root',
})
export class NotificationService {
    durationInSeconds = 4;
    config: MatSnackBarConfig = {
        duration: this.durationInSeconds * 1000,
        data: {},
        horizontalPosition: 'right',
        verticalPosition: 'top',
    };

    constructor(public snackBar: MatSnackBar) {}

    showInfo(message: string): void {
        this.showNotification(message, 'info');
    }

    showSuccess(message: string): void {
        this.showNotification(message, 'success');
    }

    showWarning(message: string): void {
        this.showNotification(message, 'warning');
    }

    showError(message: string): void {
        this.showNotification(message, 'danger');
    }

    showNotification(message: string, type: string): void {
        const action = 'x';
        const config = this.config;
        config.panelClass = ['notification', `notification-${type}`];

        this.openSnackBar(message, action, config);
    }

    openSnackBar(message: string, action?: string, config = this.config): void {
        this.snackBar.open(message, action, config);
    }
}
